import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsComponent, PmsComponent } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsComponent>
    useData={usePmsComponent}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
